'use client';

import * as React from 'react';
import { VideoContext } from './video-context';

function useVideoContext() {
  const context = React.useContext(VideoContext);

  if (!context) {
    throw new Error('`useVideoContext` must be used within a <VideoProvider>');
  }
  return context;
}

export function useVideoState() {
  const { state } = useVideoContext();

  return {
    status: state.status,
    isPlaying: state.status === 'PLAYING',
  };
}

export function useVideoActions() {
  const { dispatch } = useVideoContext();

  const play = React.useCallback(() => {
    dispatch({ type: 'PLAY_VIDEO' });
  }, [dispatch]);

  const mute = React.useCallback(() => {
    dispatch({ type: 'MUTE_VIDEO' });
  }, [dispatch]);

  return {
    play,
    mute,
  };
}
